import React from 'react';

import type { IEntriesProps } from '../IEntries';
import { ItemRepeater } from '../ItemRepeater/ItemRepeater';
import { MobileItem } from './MobileItem/MobileItem';

export const Mobile: React.FC<IEntriesProps> = props => <ItemRepeater {...props} component={MobileItem} />;
